import { render, staticRenderFns } from "./TalhaoMap.vue?vue&type=template&id=67e8fdf0&scoped=true"
import script from "./TalhaoMap.vue?vue&type=script&lang=js"
export * from "./TalhaoMap.vue?vue&type=script&lang=js"
import style0 from "./TalhaoMap.vue?vue&type=style&index=0&id=67e8fdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8fdf0",
  null
  
)

export default component.exports